import { createSlice } from "@reduxjs/toolkit";
import {Pagination, Student} from "../../../types/studentsSchema";

const initialState = {
    students: [] as Student[],
    pagination: {} as Pagination,
    isLoading: true,
    error: null,
};

const studentsSlice = createSlice({
    name: "students",
    initialState,
    reducers: {
        setStudents: (state, action) => {
            const { items, pagination } = action.payload;
            state.students = items;
            state.pagination = pagination;
            state.isLoading = false;
            state.error = null;
        },
        setLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
    },
});

export const { setStudents, setLoading, setError } = studentsSlice.actions;


export const studentsReducer = studentsSlice.reducer;

